import React, { useState, useEffect } from "react";
import "../../../theme/css/Faq.css";
import Aos from "aos";
import "aos/dist/aos.css";
import OurPdVData from "./OurPdVData";
import Iframe from 'react-iframe';
import "../../../theme/tailwind/table.css";

function CashCarry() {
    const [openIndex, setOpenIndex] = useState(null);

    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="container mx-auto px-4" id="cashcarry">
            <div className="spacing">
                <div className="startToday spacing">
                    <div className="container mx-auto" data-aos="zoom-in">
                        <div className="titleFont text-center">
                            <h2>I nostri Cash & Carry</h2>
                        </div>
                        <div className="text-center">
                            Progettati per offrire un'esperienza d'acquisto eccellente, combinando qualità, convenienza e un servizio impeccabile.
                            Ogni punto vendita offre una gamma ampia di prodotti selezionati e di alta qualità, dai freschi agli alimentari confezionati, oltre a forniture specializzate per la ristorazione e il catering.
                            Visita uno dei nostri punti vendita in Puglia per scoprire come Italy Cash può diventare il tuo partner di fiducia
                        </div>
                    </div>
                </div>
                <div className="container mx-auto">
                    <div className="faqContain table-container" data-aos="fade-up">
                        <div className="w-full border border-gray-200 rounded-lg overflow-hidden">
                            {OurPdVData.map((pdv, idx) => (
                                <div
                                    key={pdv.id}
                                    className={`border-b border-gray-200 ${openIndex === idx ? "bg-gray-50" : "bg-white"}`}
                                >
                                    <button
                                        className={`w-full text-left px-4 py-3 flex items-center justify-between font-bold text-gray-700 text-lg sm:text-xl hover:bg-gray-50 transition-colors focus:outline-none ${openIndex === idx ? "" : "collapsed"}`}
                                        onClick={() => handleToggle(idx)}
                                        type="button"
                                    >
                                        <span>{pdv.citta}</span>
                                        <span
                                          className={`transition-transform duration-200 ml-2 w-5 h-5 flex items-center justify-center ${openIndex === idx ? "rotate-180" : ""}`}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-5 h-5"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                          >
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                          </svg>
                                        </span>
                                    </button>
                                    <div
                                        className={`transition-all duration-300 ease-in-out overflow-hidden bg-white ${openIndex === idx ? "max-h-[1000px] py-4 px-4" : "max-h-0 py-0 px-4"}`}
                                    >
                                        {openIndex === idx && (
                                            <div className="titleFont text-center">
                                                <h2 className="text-3xl font-extrabold mb-4">{pdv.citta}</h2>
                                                <h3 className="text-xl font-semibold mb-6 text-red-600">{pdv.indirizzo}</h3>
                                                <h4 className="font-bold text-2xl mt-8 mb-2">Orari Apertura:</h4>
                                                <p className="mb-6 text-base">
                                                    {pdv.orario1 && <span>{pdv.orario1}<br /></span>}
                                                    {pdv.orario2 && <span>{pdv.orario2}<br /></span>}
                                                    {pdv.orario3 && <span>{pdv.orario3}<br /></span>}
                                                    {pdv.orario4 && <span>{pdv.orario4}</span>}
                                                </p>
                                                <h4 className="font-bold text-2xl mt-8 mb-2">Telefono:</h4>
                                                <p className="mb-6 text-lg">
                                                    <a href={`tel:${pdv.telefono.replaceAll(' ', '')}`} className="text-blue-600 hover:underline">{pdv.telefono}</a>
                                                </p>
                                                <h4 className="font-bold text-2xl mt-8 mb-2">E-mail:</h4>
                                                <p className="mb-8 text-lg">
                                                    <a href={`mailto:${pdv.email}`} className="text-blue-600 hover:underline">{pdv.email}</a>
                                                </p>
                                                <Iframe url={pdv.url}
                                                    width="100%"
                                                    height="450px"
                                                    id="myId"
                                                    className="iframeContactUs"
                                                    display="initial"
                                                    position="relative"
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CashCarry;
